<template>
    <div class="modal-overlay">
        <div class="modal-content max-width">
            <div class="panel-title">
                <span>
                    <h4>{{ $t('titles.performance') }} {{ this.pname }}</h4>
                </span>
                <span @click="closePanel"><i class="cursor-pointer ti-close right-side-toggle medium-icon"></i></span>
            </div>
            <div>
                <span class="mt-2">
                    <button class="btn btn-transparent" value="daily" :class="{ 'active': period === 'daily' }"
                        @click="fetchChartData('daily')">1 {{ $t('timeframe.day') }}</button>
                    <button class="btn btn-transparent" value="weekly" :class="{ 'active': period === 'weekly' }"
                        @click="fetchChartData('weekly')">1 {{ $t('timeframe.week') }}</button>
                    <button class="btn btn-transparent" value="monthly" :class="{ 'active': period === 'monthly' }"
                        @click="fetchChartData('monthly')">1
                        {{ $t('timeframe.month') }}</button>
                    <button class="btn btn-transparent" value="quarterly" :class="{ 'active': period === 'quarterly' }"
                        @click="fetchChartData('quarterly')">3
                        {{ $t('timeframe.month') }}</button>
                    <button class="btn btn-transparent" value="half_year" :class="{ 'active': period === 'half_year' }"
                        @click="fetchChartData('half_year')">6
                        {{ $t('timeframe.month') }}</button>
                    <button class="btn btn-transparent" value="annual" :class="{ 'active': period === 'annual' }"
                        @click="fetchChartData('annual')">1 {{ $t('timeframe.year') }}</button>
                    <button class="btn btn-transparent" value="three_years"
                        :class="{ 'active': period === 'three_years' }" @click="fetchChartData('three_years')">3
                        {{ $t('timeframe.year') }}</button>
                    <button class="btn btn-transparent" value="max" :class="{ 'active': period === 'max' }"
                        @click="fetchChartData('max')">{{ $t('timeframe.all') }}</button>
                </span>
            </div>
            <div class="mt-2">
                <loading-container :loading="form.performanceChartLoading">
                    <div v-if="performanceChart">
                        <apexchart type="line" height="420" :options="performanceChart.chartOptions"
                            :series="performanceChart.series" />
                    </div>
                </loading-container>
            </div>
        </div>
    </div>
</template>

<script>
import ApexCharts from 'vue-apexcharts';
import { mapGetters, mapActions } from "vuex";
import LoadingContainer from "@/components/Misc/LoadingContainer";

export default {
    name: 'PerformanceChart',
    components: {
        apexchart: ApexCharts,
        LoadingContainer
    },
    props: {
        pid: String,
        pname: String,
    },
    computed: {
        ...mapGetters({
            form: "portfolio/form",
            performanceChart: "portfolio/performanceChart"
        })
    },
    beforeMount() {
        this.fetchChartData(this.period);
    },
    data() {
        return {
            period: 'quarterly'
        };
    },
    methods: {
        ...mapActions({
            getPerformanceChart: "portfolio/getPerformanceChart"
        }),
        fetchChartData(period) {
            this.period = period;
            const params = {
                'pid' : this.pid,
                'period' : this.period
            }
            this.getPerformanceChart(params);
        },
        closePanel() {
            this.$emit('close');
        }
    }
}
</script>

<style scoped>
.max-width {
  max-width: 1000px;
}

</style>